import { useEffect } from "react";

const SITE_URL = "https://rivellaenterprise.com";

const upsert = (selector, attributes) => {
  let element = document.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
  return element;
};

export const Seo = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsert('meta[name="description"]', { name: "description", content: description });
    }

    const path = window.location.pathname.replace(/\/+$/, "") || "/";
    const url = `${SITE_URL}${path}`;

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
    upsert('meta[property="og:url"]', { property: "og:url", content: url });
  }, [title, description]);

  return null;
};
